<template>
    <v-card>
        <v-card-title>アカウント管理</v-card-title>
        <v-col class="text-right" v-if="canCreate()">
            <v-btn class="info" @click="open()">追加</v-btn>
        </v-col>
        <v-card-text>
            <v-data-table
                :headers="headers"
                :items="accounts"
                :options.sync="options"
                :server-items-length="accounts.length"
                :loading="loading"
                :item-class="validBackground"
                hide-default-footer
                class="elevation-1"
            >
                <template v-slot:[`item.shop_id`]="{ item }">
                    {{drawShop(item.shop_id)}}
                </template>
                <template v-slot:[`item.valid`]="{ item }">
                    <span v-if="item.resignation_date && moment(item.resignation_date).format('YYYY/MM/DD') <= moment().format('YYYY/MM/DD')">退職済み</span>
                    <drawValid v-else :valid="item.valid"></drawValid>
                </template>
                <template v-slot:[`item.resignation_date`]="{ item }">
                    {{ item.resignation_date ? moment(item.resignation_date).format('YYYY/MM/DD') : "" }}
                </template>
                <template v-slot:[`item.action`]="{ item }">
                    <v-btn class="edit mr-2" @click="getUser(item.id)" :dark="canEdit(item)" :disabled="!canEdit(item)">
                        編集
                    </v-btn>
                    <v-btn class="delete" @click="deleteConfirm(item.id)" :dark="canDelete(item)" :disabled="!canDelete(item)">
                        削除
                    </v-btn>
                </template>
            </v-data-table>

            <v-layout row justify-center>
                <v-dialog v-model="dialog" persistent max-width="720px">
                    <v-form v-model="valid" ref="form">
                        <v-card>
                            <v-card-title>
                                <span class="headline">{{ formTitle }}</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <v-flex xs6>
                                            <v-text-field
                                                v-model="selectedUser.name"
                                                label="ユーザ名(*)"
                                                :rules="rules.name"
                                                :counter="16"
                                                required
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-select
                                                v-model="selectedUser.shop_id"
                                                :items="shops"
                                                label="所属店舗"
                                                required
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs12 sm6 md6>
                                            <v-text-field
                                                v-model="selectedUser.login_id"
                                                label="ID(*)"
                                                :rules="rules.loginId"
                                                :counter="16"
                                                required
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6 md6>
                                            <v-text-field
                                                v-model="
                                                    selectedUser.login_pass
                                                "
                                                type="password"
                                                label="パスワード"
                                                :rules="rules.loginPass"
                                                required
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 v-if="this.selectedUser.id != -1">
                                            <v-menu
                                                :close-on-content-click="true"
                                                transition="scale-transition"
                                                offset-y max-width="290px"
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="selectedUser.resignation_date"
                                                        readonly label="退職日"
                                                        append-icon="mdi-calendar"
                                                        persistent-hint v-bind="attrs"
                                                        clearable
                                                        v-on="on"
                                                        width="120px">
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="selectedUser.resignation_date"
                                                    :day-format="(resignation_date) => new Date(resignation_date).getDate()"
                                                    no-title>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-select
                                                v-model="privilege"
                                                :items="ACCOUNT.PRIVILEGE.LIST"
                                                outlined
                                                chips
                                                label="権限"
                                                multiple
                                                :disabled="!canSelectPrivilege()"
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-checkbox
                                                v-model="selectedUser.show_online"
                                                label="オンライン店舗表示"
                                                :true-value="1"
                                                :false-value="0"
                                            ></v-checkbox>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    class="info"
                                    @click="save"
                                    :disabled="!valid"
                                    >保存</v-btn
                                >
                                <v-btn @click="close">キャンセル</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-form>
                </v-dialog>
            </v-layout>

            <v-layout row justify-center>
                <v-dialog v-model="deleteDialog" persistent max-width="290px">
                    <v-card>
                        <v-card-title> 削除しますか？ </v-card-title>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn dark class="delete" @click="deleteUser"
                                >削除</v-btn
                            >
                            <v-btn @click="close">キャンセル</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-layout>
        </v-card-text>
    </v-card>
</template>

<style lang="css">
.invalid {
    background-color: rgb(230, 230, 230);
}
</style>
<script>
import moment from "moment";
import drawValid from "@/components/account/valid.vue";
import ACCOUNT from "@/consts/account.js";

export default {
    title: "アカウント管理",
    name: "account",
    components: {
        drawValid,
    },
    data: () => ({
        accounts: [],
        shops: [],
        loading: true,
        options: {},
        headers: [
            { text: "名前", value: "name", align: "start", sortable: false },
            { text: "所属", value: "shop_id", align: "start", sortable: false },
            { text: "ID", value: "login_id", align: "start", sortable: false },
            { text: "ステータス", value: "valid", align: "center", sortable: false },
            { text: "退職日", value: "resignation_date", align: "center", sortable: false},
            { text: "操作", value: "action", align: "center", sortable: false },
        ],
        ACCOUNT: ACCOUNT,
        dialog: false,
        deleteDialog: false,
        valid: false,
        privilege: [],
        defaultUser: {
            id: -1,
            name: "",
            shop_id: 0,
            login_id: "",
            login_pass: "",
            privilege: 0,
            valid: 1,
            show_online: 0,
        },
        selectedUser: {
            id: -1,
            name: "",
            shop_id: 0,
            login_id: "",
            login_pass: "",
            privilege: 0,
            valid: 1,
            show_online: 0,
            resignation_date: ""
        },
        rules: {
            name: [
                (v) => !!v || "アカウント名を入れてください",
                (v) => v.length <= 16 || "アカウント名は16文字までです",
            ],
            loginId: [
                (v) => !!v || "ログインIDを入れてください",
                (v) =>
                    (4 <= v.length && v.length <= 16) ||
                    "ログインIDは4～16文字までです",
            ],
            loginPass: [
                (v) => !v || v.length <= 16 || "パスワードは16文字までです",
            ],
        },
        moment: moment,
    }),
    computed: {
        formTitle() {
            return (
                "アカウント" + (this.selectedUser.id === -1 ? "追加" : "編集")
            );
        },
    },
    watch: {
        options: {
            handler() {
                this.loadList();
            },
            deep: true,
        },
        privilege(values) {
            this.selectedUser.privilege = 0;
            values.forEach(v => this.selectedUser.privilege |= v);
        },
    },
    methods: {
        async loadList() {
            this.loading = true;
            try {
                await this.$axios
                    .get("/api/v1/account")
                    .then((response) => {
                        this.accounts = response.data.accounts;
                        this.shops = response.data.shops;
                        this.shops.push({
                            value: 0,
                            text: "所属無し"
                        });
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } catch (error) {
                console.log(error);
            }
            this.loading = false;
        },
        created() {
            this.loadList();
        },
        getUser(id) {
            this.selectedUser.id = id;
            this.$axios
                .get(`/api/v1/account/${id}`)
                .then((response) => {
                    this.selectedUser = response.data.account;
                    this.selectedUser.resignation_date = this.formatDate(this.selectedUser.resignation_date)
                    this.privilege = [];
                    let privilege = this.selectedUser.privilege
                    for(let i = 0; privilege > 0; privilege >>= 1, ++i) {
                        if(privilege & 1) this.privilege.push(1 << i);
                    }
                    console.log("Edit : id=" + this.selectedUser.id);
                    this.dialog = true;
                })
                .catch((error) => {
                    console.log("Error : " + error);
                });
        },
        save() {
            if (this.selectedUser.id == -1) {
                // 追加
                this.createUser(this.selectedUser);
            } else {
                // 更新
                this.updateUser(this.selectedUser);
            }
            this.close();
        },
        createUser(userInfo) {
            this.$axios
                .post("/api/v1/account", { userInfo })
                .then((response) => {
                    console.log("Created : id=" + response.data.id);
                })
                .catch((error) => {
                    console.log("Error : " + error);
                })
                .then(() => {
                    this.loadList();
                });
        },
        updateUser(userInfo) {
            this.$axios
                .put(`/api/v1/account/${this.selectedUser.id}`, { userInfo })
                .then((response) => {
                    console.log("Updated : id=" + response.data.id);
                })
                .catch((error) => {
                    console.log("Error : " + error);
                })
                .then(() => {
                    this.loadList();
                });
        },
        deleteConfirm(id) {
            this.selectedUser.id = id;
            this.deleteDialog = true;
        },
        deleteUser() {
            this.$axios
                .delete(`/api/v1/account/${this.selectedUser.id}`)
                .catch((error) => {
                    console.log("Error : " + error);
                })
                .then(() => {
                    this.loadList();
                    this.close();
                });
        },
        open() {
            if(this.$refs.form) this.$refs.form.resetValidation();
            this.dialog = true;
        },
        close() {
            this.dialog = false;
            this.deleteDialog = false;
            this.selectedUser = Object.assign({}, this.defaultUser);
            this.privilege = [];
        },
        canCreate() {
            const self = this.$store.state.user;
            if((self.privilege & (ACCOUNT.PRIVILEGE.VAL.SYSTEM_ADMIN | ACCOUNT.PRIVILEGE.VAL.CUSTOMER_CREATE)) != 0) return true;
            return false;
        },
        canSelectPrivilege() {
            const self = this.$store.state.user;
            if((self.privilege & ACCOUNT.PRIVILEGE.VAL.SYSTEM_ADMIN) != 0) return true;
            if((self.privilege & ACCOUNT.PRIVILEGE.VAL.ACCOUNT_EDIT) != 0) return true;
            return false;
        },
        canEdit(user) {
            const self = this.$store.state.user;
            // 自身は編集可能
            if(user.id == self.id) return true;

            // システム管理者は誰でも編集可能
            if((self.privilege & ACCOUNT.PRIVILEGE.VAL.SYSTEM_ADMIN) != 0) return true;

            if((self.privilege & ACCOUNT.PRIVILEGE.VAL.ACCOUNT_EDIT) != 0) {
                // システム管理者以外は編集可能
                if((user.privilege & ACCOUNT.PRIVILEGE.VAL.SYSTEM_ADMIN) != 0) return false;
                return true;
            }
            return false;
        },
        canDelete(user) {
            const self = this.$store.state.user;
            // 自身は削除できない
            if(user.id == self.id) return false;

            // システム管理者は誰でも削除可能
            if((self.privilege & ACCOUNT.PRIVILEGE.VAL.SYSTEM_ADMIN) != 0) return true;

            if((self.privilege & ACCOUNT.PRIVILEGE.VAL.ACCOUNT_DELETE) != 0) {
                // システム管理者と、同じ権限を持つユーザー以外は削除可能
                if((user.privilege & ACCOUNT.PRIVILEGE.VAL.SYSTEM_ADMIN) != 0) return false;
                if((user.privilege & ACCOUNT.PRIVILEGE.VAL.ACCOUNT_DELETE) != 0) return false;
                return true;
            }
            return false;
        },
        drawShop(shopId) {
            const type = this.shops.find( v => v.value == shopId );
            if(!type) return "";
            return type.text;
        },
        validBackground(item) {
            return item.valid ? '' : 'invalid'
        },
        formatDate(date) {
            if (!date) return null
            return moment(date).format("yyyy-MM-DD")
        },
    },
};
</script>
